import { render } from "./UserMessageModal.vue?vue&type=template&id=7a0d6f76&scoped=true"
import script from "./UserMessageModal.vue?vue&type=script&lang=js"
export * from "./UserMessageModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7a0d6f76"

export default script